import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            isCasaDelTabaco: 'global/getIsCasaDelTabaco'
        })
    },
    methods: {
        generateDefImg(name) {
            const basePath = '/img/icons/casa/';

            if (!this.isCasaDelTabaco) {
                const isTheme =
                    process.env.THEME === 'ECATERIX' || process.env.THEME === 'NOVAPORTA' || process.env.THEME === 'FOUNDATION';

                if (name === 'facebook') {
                    return isTheme ? require('~/static/img/icons/facebook.svg') : 'img/icons/facebook.svg';
                }
                if (name === 'instagram') {
                    return isTheme ? require('~/static/img/icons/instagram.svg') : 'img/icons/instagram.svg';
                }
                if (name === 'tiktok') {
                    return isTheme ? require('~/static/img/icons/tiktok.svg') : 'img/icons/tiktok.svg';
                }
                if (name === 'twitter') {
                    return isTheme ? require('~/static/img/icons/twitter.svg') : 'img/icons/twitter.svg';
                }
                if (name === 'viber') {
                    return isTheme ? require('~/static/img/icons/viber.svg') : 'img/icons/viber.svg';
                }
                if (name === 'whatsapp') {
                    return isTheme ? require('~/static/img/icons/wats-up-icn.svg') : 'img/icons/wats-up-icn.svg';
                }
                if (name === 'linkedin') {
                    return isTheme ? require('~/static/img/icons/linkedin.svg') : 'img/icons/linkedin.svg';
                }
                if (name === 'youtube') {
                    return isTheme ? require('~/static/img/icons/youtube.svg') : 'img/icons/youtube.svg';
                }
                if (name === 'telegram') {
                    return isTheme ? require('~/static/img/icons/telegram.svg') : 'img/icons/telegram.svg';
                }
                if (name === 'pinterest') {
                    return isTheme ? require('~/static/img/icons/pinterest.svg') : 'img/icons/pinterest.svg';
                }
                return null;
            }

            const icons = {
                facebook: 'facebook.svg',
                instagram: 'instagram.svg',
                tiktok: 'tiktok.svg',
                twitter: 'twitter.svg',
                viber: 'viber.svg',
                whatsapp: 'whatsup.svg',
                youtube: 'youtube.svg',
                pinterest: 'pinterest.svg',
                telegram: 'telegram.svg',
                linkedin: 'linkedin.svg'
            };

            return `${basePath}${icons[name] || ''}`;
        }
    }
};

// import { mapGetters } from 'vuex';

// export default {
//     computed: {
//         ...mapGetters({
//             isCasaDelTabaco: 'global/getIsCasaDelTabaco'
//         })
//     },
//     methods: {
//         generateDefImg(name) {
//             const basePath = '/img/icons/casa/';

//             if (!this.isCasaDelTabaco) {
//                 const isTheme = process.env.THEME === 'ECATERIX' || process.env.THEME === 'NOVAPORTA';
//                 if (name === 'facebook') {
//                     return isTheme ? require('~/static/img/icons/facebook.svg') : 'img/icons/facebook.svg';
//                 }
//                 if (name === 'instagram') {
//                     return isTheme ? require('~/static/img/icons/instagram.svg') : 'img/icons/instagram.svg';
//                 }
//                 if (name === 'tiktok') {
//                     return isTheme ? require('~/static/img/icons/tiktok.svg') : 'img/icons/tiktok.svg';
//                 }
//                 if (name === 'twitter') {
//                     return isTheme ? require('~/static/img/icons/twitter.svg') : 'img/icons/twitter.svg';
//                 }
//                 if (name === 'viber') {
//                     return isTheme ? require('~/static/img/icons/viber.svg') : 'img/icons/viber.svg';
//                 }
//                 if (name === 'whatsapp') {
//                     return isTheme ? require('~/static/img/icons/wats-up-icn.svg') : 'img/icons/wats-up-icn.svg';
//                 }
//                 if (name === 'linkedin') {
//                     return isTheme ? require('~/static/img/icons/linkedin.svg') : 'img/icons/linkedin.svg';
//                 }
//                 if (name === 'youtube') {
//                     return isTheme ? require('~/static/img/icons/youtube.svg') : 'img/icons/youtube.svg';
//                 }
//                 if (name === 'telegram') {
//                     return isTheme ? require('~/static/img/icons/telegram.svg') : 'img/icons/telegram.svg';
//                 }
//                 if (name === 'pinterest') {
//                     return isTheme ? require('~/static/img/icons/pinterest.svg') : 'img/icons/pinterest.svg';
//                 }
//                 return null;
//             }

//             const icons = {
//                 facebook: 'facebook.svg',
//                 instagram: 'instagram.svg',
//                 tiktok: 'tiktok.svg',
//                 twitter: 'twitter.svg',
//                 viber: 'viber.svg',
//                 whatsapp: 'whatsup.svg',
//                 youtube: 'youtube.svg',
//                 pinterest: 'pinterest.svg',
//                 telegram: 'telegram.svg',
//                 linkedin: 'linkedin.svg'
//             };

//             return `${basePath}${icons[name] || ''}`;
//         }
//     }
// };
